import { PropsWithChildren, useState } from 'react';

import {
  ChakraFlex,
  DropdownV2,
  FAIconName,
  FireflyButton,
  InputGroupV2,
  ModalV2,
  Text,
} from '@equip.health/ui';

const DELETE_REASONS = [
  {
    label: 'Duplicate billing periods',
    value: 'DUPLICATE',
  },
  {
    label: 'Added billing period by mistake',
    value: 'ADDED_BY_MISTAKE',
  },
  {
    label: 'Other',
    value: 'OTHER',
  },
];

interface DeleteConfirmationModalProps extends PropsWithChildren {
  isOpen: boolean;
  isPrimaryButtonDisabled: boolean;
  onConfirmDelete: (deleteReason: string) => void;
  setIsOpen: (isOpen: boolean) => void;
}

const TOP_LEVEL_ID = 'delete-confirm-modal';

const DeleteConfirmationModal = ({
  isOpen,
  isPrimaryButtonDisabled,
  onConfirmDelete,
  setIsOpen,
}: DeleteConfirmationModalProps) => {
  const [deleteReason, setDeletReason] = useState<string | null>();
  const handleClose = () => {
    setIsOpen(false);
    setDeletReason(null);
  };
  return (
    <ModalV2
      footerContent={
        <ChakraFlex justifyContent="space-between" width="100%">
          <FireflyButton
            id={`${TOP_LEVEL_ID}__delete-bp`}
            leftIcon={FAIconName.XmarkRegular}
            onClick={handleClose}
            variant="secondary"
          >
            Cancel
          </FireflyButton>

          <FireflyButton
            id={`${TOP_LEVEL_ID}__cancel-deletion`}
            isDisabled={!deleteReason}
            isLoading={isPrimaryButtonDisabled}
            leftIcon={FAIconName.trashRegular}
            onClick={() => {
              onConfirmDelete(deleteReason);
            }}
            variant="accent.critical"
          >
            Delete billing period
          </FireflyButton>
        </ChakraFlex>
      }
      id={TOP_LEVEL_ID}
      isOpen={isOpen}
      onClose={handleClose}
      title="Delete billing period"
    >
      <ChakraFlex flexDirection="column" gap="5">
        <Text
          color="neutral.primary"
          id={`${TOP_LEVEL_ID}__subtitle`}
          variant="body"
        >
          Please note, once you delete this billing period, you will not be able
          to undo this action and it will no longer appear on the patient
          profile.
        </Text>
        <InputGroupV2
          id={`${TOP_LEVEL_ID}__delete-reason`}
          isRequired
          label="Delete reason"
        >
          <DropdownV2
            id={`${TOP_LEVEL_ID}__delete-reason-options`}
            menuOptions={(DELETE_REASONS ?? []).map(({ label, value }) => ({
              label,
              value,
            }))}
            onOptionClick={(value: string) => setDeletReason(value)}
            placeholder="Please choose"
            value={deleteReason}
          />
        </InputGroupV2>
      </ChakraFlex>
    </ModalV2>
  );
};

export default DeleteConfirmationModal;
